// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import Link from "next/link";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Router from "next/router";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CookieHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as SharedHelper$PorterinFeature from "../../../core/helpers/SharedHelper.mjs";
import * as CookieConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as LanguageSelectorModuleScss from "../styles/LanguageSelector.module.scss";

var styles = LanguageSelectorModuleScss;

function LanguageSelectorCmp(Props) {
  var content = Props.content;
  var router = Router.useRouter();
  var locales = content.locales;
  var toggle_icon = content.toggle_icon;
  var language_icon = content.language_icon;
  var locale = router.locale;
  var asPath = router.asPath;
  var match = React.useState(function () {
        return Caml_array.get(locales, 0);
      });
  var setSelectedLocale = match[1];
  var selectedLocale = match[0];
  var handleLocaleChange = function (newLocale) {
    Curry._1(setSelectedLocale, (function (param) {
            return newLocale;
          }));
    CookieHelpers$PorterinUtils.setCookie(SharedHelper$PorterinFeature.getNextLocaleCookieString(newLocale.locale_code));
  };
  var updateLocale = function (localeOption) {
    if (localeOption !== undefined) {
      return handleLocaleChange(localeOption);
    } else {
      return handleLocaleChange(Caml_array.get(locales, 0));
    }
  };
  React.useEffect((function () {
          var nextLocaleCookie = CookieHelpers$PorterinUtils.getCookie(CookieConstants$PorterinUtils.next_locale);
          var localeFromCookie = locales.find(function (l) {
                return l.locale_code === nextLocaleCookie;
              });
          var currentLocale = locales.find(function (l) {
                return l.locale_code === locale;
              });
          var currentLocale$1 = currentLocale === undefined ? undefined : Caml_option.some(currentLocale);
          if (localeFromCookie !== undefined && nextLocaleCookie === locale) {
            Curry._1(setSelectedLocale, (function (param) {
                    return localeFromCookie;
                  }));
          } else {
            updateLocale(currentLocale$1);
          }
        }), [
        locale,
        locales
      ]);
  return React.createElement("div", {
              className: styles.container
            }, React.createElement("div", {
                  className: styles["label-container"],
                  onMouseEnter: (function (param) {
                      
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: language_icon.path,
                      height: 20.0,
                      width: 20.0,
                      alt: language_icon.alt_text
                    }), React.createElement("label", {
                      className: styles.label
                    }, selectedLocale.label), React.createElement(NextImage$PorterinFeature.make, {
                      src: toggle_icon.path,
                      height: 20.0,
                      width: 20.0,
                      alt: toggle_icon.alt_text
                    })), React.createElement("div", {
                  className: styles["language-list-container"]
                }, React.createElement("ul", {
                      className: styles["language-list"],
                      id: "language-select"
                    }, $$Array.map((function (locale) {
                            var isSelected = locale.locale_code === selectedLocale.locale_code;
                            return React.createElement(Link, {
                                        href: asPath,
                                        replace: true,
                                        children: React.createElement("div", {
                                              key: locale.locale_code,
                                              className: "" + styles["language-item"] + " " + (
                                                isSelected ? styles.selected : ""
                                              ) + "",
                                              onClick: (function (param) {
                                                  var eventData = {
                                                    selected_language: LocaleHelpers$PorterinUtils.localeToString(locale.locale_code),
                                                    language_code: locale.locale_code,
                                                    previous_language: LocaleHelpers$PorterinUtils.localeToString(selectedLocale.locale_code),
                                                    previous_language_code: selectedLocale.locale_code
                                                  };
                                                  PublishEventsHelper$PorterinFeature.publishEventsV2(GAEventsConstants$PorterinFeature.gaLanguageChange, eventData);
                                                  SharedHelper$PorterinFeature.triggerAcceptAllCookies(locale.locale_code);
                                                  handleLocaleChange(locale);
                                                })
                                            }, React.createElement("div", {
                                                  className: styles["language-code"]
                                                }, locale.display_code), React.createElement("span", undefined, locale.label)),
                                        locale: locale.locale_code
                                      });
                          }), locales))));
}

var Link$1;

var make = LanguageSelectorCmp;

export {
  Link$1 as Link,
  styles ,
  make ,
}
/* styles Not a pure module */
